import React from "react";
import "./ThinksToDo.scss";
import {
  ApprovedIcon,
  CalendarTodayGreen,
  LikeIcon,
  RecruiterEmployeeIcon,
  RejectIcon,
} from "../../assets/images";
import { LoginResponseType } from "../../redux/auth/authTypes";
import { ApprovalListType } from "../../redux/hrms/hrmsTypes";
import {
  currentDate,
  getTodayDateWithTimeStamp,
  reverseDate,
} from "../../utils/commonFunctions";
import CustomizedAvatar from "../commons/CircularAvatar/CustomizedAvatar";
import BoxLoader from "../commons/BoxLoader/BoxLoader";
type AppProps = {
  handleFeedBackModal: (data?: string) => void;
  history: any;
  loginData: LoginResponseType;
  thinksToDoFetching: boolean;
  approvalList: ApprovalListType[] | [];
  setIsApproved: React.Dispatch<React.SetStateAction<boolean>>;
  setIsInterviewApproval: React.Dispatch<React.SetStateAction<boolean>>;
  setApprovalId: React.Dispatch<React.SetStateAction<string>>;
  isApproved: boolean;
};
const PendingInterviewApprovals = ({
  handleFeedBackModal,
  history,
  loginData,
  thinksToDoFetching,
  approvalList,
  setIsApproved,
  isApproved,
  setIsInterviewApproval,
  setApprovalId,
}: AppProps) => {
  approvalList = approvalList?.filter(
    (el: ApprovalListType) => el?.comment?.length === 0
  );

  const handleApproved = () => {
    setIsApproved(true);
    setIsInterviewApproval(true);
  };
  const handleReject = () => {
    setIsInterviewApproval(true);
    setIsApproved(false);
  };
  return (
    <div
      className="boxs scheduled-upcoming-interviews"
      style={{ overflow: "auto" }}
    >
      {thinksToDoFetching ? (
        <BoxLoader style={{ height: "100%" }} />
      ) : (
        <>
          <div className="d-flex justify-content-between">
            <div
              className="p-4 d-flex align-items-center w-75"
              style={{ gap: "3%" }}
            >
              <div>
                <img src={RecruiterEmployeeIcon} alt="calendar-clock" />
              </div>
              <div>
                <p className="m-0" style={{ color: "#7c8db0" }}>
                  RECRUITMENT TRACKER
                </p>
                <p
                  className="m-0"
                  style={{ fontSize: "14px", fontWeight: 600 }}
                >
                  Pending Interview Approvals
                </p>
              </div>
            </div>
            <div className="d-flex align-items-center p-4">
              <span
                className="mr-3"
                style={{
                  textDecoration: "underline",
                  color: "#dd4433",
                  cursor: "pointer",
                }}
                onClick={() => {
                  history.push({
                    pathname: `/things-to-do/interview-list`,
                    state: "Approval Pending",
                  });
                }}
              >
                View All
              </span>
            </div>
          </div>
          <hr className="m-0"></hr>

          {approvalList?.length > 0 ? (
            approvalList?.map((el: ApprovalListType) => {
              let toDayDate = getTodayDateWithTimeStamp();

              let timeCheck = false;

              return (
                <div>
                  <div
                    className="d-flex align-items-center pt-3 pb-1 pl-3 pr-3"
                    style={{ gap: "3%" }}
                  >
                    <div>
                      <CustomizedAvatar
                        name={`${el?.applicant_details?.name}`}
                        image={el?.applicant_details?.profile_pic?.file_url}
                        style={{ width: "58px", fontSize: "21px" }}
                      />
                    </div>
                    <div>
                      <p
                        className="mb-1"
                        style={{
                          fontSize: "15px",
                          fontWeight: 500,
                          textDecoration: "underline",
                          cursor: "pointer",
                        }}
                        onClick={() => {
                          setIsInterviewApproval(true);
                          handleFeedBackModal(el?.hrms_id);
                          setApprovalId(el?._id);
                        }}
                      >
                        {el?.applicant_details?.name} -
                        {el?.applicant_details?.position}.{" "}
                        {el?.applicant_details?.location}.
                      </p>
                      <div
                        style={{
                          color: "#28a745",
                          display: "flex",
                          alignItems: "center",
                          fontWeight: 500,
                        }}
                        className="mt-2"
                      >
                        <img src={CalendarTodayGreen} alt="calender-icon" />{" "}
                        <div className="ml-2">
                          {el?.created_at?.split(" ")[0] ===
                          reverseDate(currentDate())
                            ? "Today "
                            : ""}

                          {el?.created_at?.split(" ")[0]}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    className="mt-1 d-flex pt-0 pb-3 pl-3 pr-3"
                    style={{ gap: "3%" }}
                  >
                    <div
                      style={{
                        // visibility: "hidden",
                        width: "58px",
                        height: "10px",
                      }}
                    >
                      {/* <CustomizedAvatar
                    name={`${el?.applicant_details?.name}`}
                    image={""}
                    style={{ width: "8px", fontSize: "21px" }}
                  /> */}
                    </div>
                    <div
                      style={{ cursor: "pointer", height: "fit-content" }}
                      onClick={() => {
                        handleApproved();
                        handleFeedBackModal(el?.hrms_id);
                        setApprovalId(el?._id);
                      }}
                    >
                      <img src={ApprovedIcon} alt="approved-icon" />
                      <span
                        className="ml-2"
                        style={{
                          color: "#dd4433",
                          fontSize: "16px",
                          fontWeight: 500,

                          cursor: "pointer",
                        }}
                      >
                        Approve
                      </span>
                    </div>
                    <div
                      style={{ height: "fit-content", cursor: "pointer" }}
                      onClick={() => {
                        handleReject();
                        handleFeedBackModal(el?.hrms_id);
                        setApprovalId(el?._id);
                      }}
                    >
                      <img src={RejectIcon} alt="reject-icon" />
                      <span className="ml-2">Reject</span>
                    </div>
                  </div>
                  <hr style={{ marginTop: 0 }}></hr>
                </div>
              );
            })
          ) : (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "70%",
                flexDirection: "column",
              }}
            >
              <img src={LikeIcon} alt="like-icon" />
              <div
                className="mt-3"
                style={{
                  fontSize: "19px",
                  fontWeight: 600,
                  textAlign: "center",
                }}
              >
                Congratulations! You don't have any<br></br> pending interview
                approvals.
              </div>
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default PendingInterviewApprovals;
